import BaseProxy from './base';

/**
 * 福利中心
 */

const apiUrlConf = {
  getTasks: '/fixed/taskListForUser',
  finish: '/fixed/finish',
};

class Fixed extends BaseProxy {
  async getTasks(data) {
    const response = await this.submit('post', apiUrlConf.getTasks, data);
    return response;
  }

  async finish(data) {
    const response = await this.submit('post', apiUrlConf.finish, data);
    return response;
  }
}
const FixedProxy = new Fixed();
export default FixedProxy;
